import { restApiCallback } from 'api/typed';
import { RestApiDefinition } from 'api/types';
import { TIMEOUT_CONFIG } from 'constants/checkout-api-timeout';

const postDefinition = {
  service: 'order-payment',
  endpoint: 'orders/${customerOrderId}/payments/gifting/gift-cards/payments',
  verbs: ['post'],
  defaultVersion: 3,
  timeout: TIMEOUT_CONFIG,
} as const satisfies RestApiDefinition;

const deleteDefinition = {
  service: 'order-payment',
  endpoint: 'orders/${customerOrderId}/payments/gifting/gift-cards/payments/${giftCardPaymentId}',
  verbs: ['delete'],
  defaultVersion: 3,
  timeout: TIMEOUT_CONFIG,
} as const satisfies RestApiDefinition;

export interface OrderGiftCardsPaymentResponse {
  id: string;
  balance: number;
  maskedCardNumber: string;
  status: string;
  updateTimestamp: string;
}

export default {
  post: restApiCallback(postDefinition, 'post')<OrderGiftCardsPaymentResponse>,
  delete: restApiCallback(deleteDefinition, 'delete')<OrderGiftCardsPaymentResponse>,
};
